import {StateProvider} from 'angular-ui-router';
import {AuthGuard} from '../auth/auth-guard';
import './operational.css';

export const configStates = ($stateProvider:StateProvider) => {
  const stateData:any = {};
  stateData[AuthGuard.REQUIRES_AUTH_KEY] = true;
  $stateProvider.state('operational', {
    url: '/operational',
    abstract: true,
    component: 'imomoOperational',
    data: stateData
  });
  $stateProvider.state('operational.options', {
    parent: 'operational',
    url: '',
    component: 'imomoOperationalOptions'
  });
  $stateProvider.state('operational.input', {
    parent: 'operational',
    url: '/input?telegrams',
    component: 'imomoOperationalInput',
    params: {
      telegrams: {
        dynamic: true,
        array: true
      }
    }
  });
  $stateProvider.state('operational.journal', {
    parent: 'operational',
    url: '/journal',
    component: 'imomoOperationalJournal'
  });
  $stateProvider.state('operational.bulletin', {
    parent: 'operational',
    url: '/bulletin/:type',
    component: 'imomoOperationalBulletin'
  });
  $stateProvider.state('operational.bulk-data', {
    parent: 'operational',
    url: '/bulk-data',
    component: 'imomoOperationalBulkDataDownload'
  });
};
configStates.$inject = ['$stateProvider'];

const operationalComponent:ng.IComponentOptions = {
  template: '<ui-view class="inner-outlet"></ui-view>'
};
export default operationalComponent;







/** WEBPACK FOOTER **
 ** ./app/operational/operational.component.ts
 **/